export const durations = {
  sm: '86ms',
  md: '150ms',
  lg: '250ms',
  xl: '300ms',
};

export const easings = {
  base: 'ease-out',
};
